export * from './receipting.component';